import { useState } from 'react'
import { BulletResults } from '../BulletResults/BulletResults'
import { insightTabs } from '../../Insights'
import ReactECharts from 'echarts-for-react'
import { ScoopTheme } from '../../../../Insights/Style'
import { buildPackedCircleOption } from '../PackedCircleOption'
import { ProfilePanel } from '../ProfilePanel/ProfilePanel'
import { ArrowSquareOutIcon, InfoIcon } from '@phosphor-icons/react'
import { ScoopGrid, ScoopTooltip, ScoopButton, ScoopText, ScoopColumn } from '../../../../ui'
import styles from './ClusterResult.module.scss'

export const ClusterResult = ({
    mlResults,
    onSaveModel,
    handleSendMessage,
    selectedTab,
    setSelectedTab,
    setMlResults,
    mlConfig,
    setMlConfig,
    selectedInbox,
    server,
}) => {
    const [selected, setSelected] = useState(null)

    const handleOpenInStudio = () => {
        if (setSelectedTab) {
            setSelectedTab(insightTabs[1].key)
            setMlResults(mlResults)
            mlConfig.dateToUSe = mlResults.filterDate
            mlConfig.modelType = 'cluster'
            if (mlResults.filter) {
                mlConfig.filter = mlResults.filter
                mlConfig.filterDescription = mlResults.filterDescription
            }
            setMlConfig({ ...mlConfig })
        }
    }

    let option = null
    if (mlResults?.clusters) {
        option = buildPackedCircleOption(mlResults.clusters, 400, 400)
    }
    const onEvents = {
        click: (params) => {
            setSelected({ ...params.data })
        },
    }

    return (
        <>
            {mlResults && mlResults.error && (
                <div className={styles.errorContainer}>
                    <BulletResults mlResults={mlResults} />
                </div>
            )}
            {mlResults && mlResults.numInstances && (
                <div className={styles.resultsContainer}>
                    <ScoopGrid container gap={16} className={styles.gridContainer}>
                        <ScoopGrid item xs={10}>
                            <ScoopColumn>
                                <ScoopText variant="h2" className={styles.title}>
                                    Segmentation/Clustering Results
                                    <ScoopTooltip title="Segmentation/clustering use machine learning to find common groups within your data. It looks at all the columns specified and finds the logical groupings inherent in the data.">
                                        <InfoIcon size={14} className={styles.superAlign} />
                                    </ScoopTooltip>
                                </ScoopText>
                                <ScoopText className={styles.metadataBox}>
                                    <strong>Data rows: </strong>
                                    {(mlResults.numInstances ?? 0).toLocaleString()}
                                </ScoopText>
                            </ScoopColumn>
                        </ScoopGrid>
                        <ScoopGrid item xs={1.5}>
                            {onSaveModel && (
                                <ScoopButton onClick={onSaveModel}>Save/Apply Model</ScoopButton>
                            )}
                        </ScoopGrid>
                        <ScoopGrid item xs={0.5}>
                            {selectedTab === insightTabs[0].key && (
                                <ScoopTooltip title={'Open in Data Science Discovery Studio'}>
                                    <ScoopButton
                                        variant="icon"
                                        size="xs"
                                        onClick={handleOpenInStudio}
                                    >
                                        <ArrowSquareOutIcon size={20} />
                                    </ScoopButton>
                                </ScoopTooltip>
                            )}
                        </ScoopGrid>
                        <ScoopGrid item xs={12} className={styles.metadataBox}>
                            <div>
                                <strong>Columns used:</strong>&nbsp;
                                {mlResults?.columns.map((col) => col.name)?.join(', ')}
                            </div>
                            {mlResults?.filterDescription && (
                                <div>
                                    <strong>Filters:</strong>&nbsp;{mlResults?.filterDescription}
                                </div>
                            )}
                        </ScoopGrid>
                        {mlResults && option && (
                            <ScoopGrid item xs={6} className={styles.chartContainer}>
                                <ReactECharts
                                    style={{ height: 400, width: 400 }}
                                    option={option}
                                    notMerge={true}
                                    lazyUpdate={true}
                                    theme={ScoopTheme}
                                    onEvents={onEvents}
                                />
                            </ScoopGrid>
                        )}
                        {mlResults && option && (
                            <ScoopGrid item xs={6} className={styles.profileContainer}>
                                {selected ? (
                                    <ProfilePanel
                                        key={selected.clusterID}
                                        cluster={selected}
                                        server={server}
                                        selectedInbox={selectedInbox}
                                    />
                                ) : (
                                    <ScoopText className={styles.emptyStateText}>
                                        Click a bubble to see details
                                    </ScoopText>
                                )}
                            </ScoopGrid>
                        )}
                        <ScoopGrid item xs={12} className={styles.bulletSection}>
                            <BulletResults
                                mlResults={mlResults}
                                handleSendMessage={handleSendMessage}
                            />
                        </ScoopGrid>
                    </ScoopGrid>
                </div>
            )}
        </>
    )
}
